export enum ImageLocation {
  MainPhoto = 1,
  GalleryPhoto,
  ViewPhoto,
  PhotoEditor,
}
